export const MIN_USER_SEARCH_LENGTH = 3;

export const DEFAULT_USER_SEARCH_FILTERS = {
  page: 1,
  perPage: 25,
  accountState: "",
};

export const AFFILIATION_TYPE_LABELS = {
  sp_admin: "SP Admin",
  sp_manager: "SP Manager",
  hr_officer: "HR Officer",
  worker: "Worker",
};

export const formatAffiliationType = (affiliationType) =>
  AFFILIATION_TYPE_LABELS[affiliationType] || affiliationType || "—";

export const formatUserTypeLabel = (userType) => {
  switch (userType) {
    case "super_admin":
      return "Platform staff";
    case "sp_admin":
      return "SP Admin";
    case "sp_manager":
      return "SP Manager";
    case "hr_officer":
      return "HR Officer";
    case "sp_standard_user":
      return "Standard User";
    case "sp_cos":
      return "Support Coordinator";
    default:
      return userType || "—";
  }
};

export const canRunUserSearch = (search) =>
  typeof search === "string" && search.trim().length >= MIN_USER_SEARCH_LENGTH;

export const shouldApplySearchFilter = (search) => canRunUserSearch(search);

export const buildUserSearchQuery = ({
  search = "",
  email = "",
  accountState = "",
  page = DEFAULT_USER_SEARCH_FILTERS.page,
  perPage = DEFAULT_USER_SEARCH_FILTERS.perPage,
} = {}) => {
  const params = new URLSearchParams();
  const trimmedSearch =
    typeof search === "string" && search.trim()
      ? search.trim()
      : typeof email === "string"
        ? email.trim()
        : "";

  if (shouldApplySearchFilter(trimmedSearch)) {
    params.append("search", trimmedSearch);
  }

  if (typeof accountState === "string" && accountState.trim()) {
    params.append("account_state", accountState.trim());
  }

  params.append("page", String(page));
  params.append("per_page", String(perPage));

  return `super-admin/users/search?${params.toString()}`;
};
